// src/components/modals/IssueVerifyModal.jsx
import React, { Component } from 'react';

class IssueVerifyModal extends Component {
    render() {
        const {
            show,
            raisedBy,
            timestamp,
            verifyRemarks,
            onClose,
            onRemarksChange,
            onSubmit,
            isSubmitDisabled,
            formatTimestamp
        } = this.props;

        if (!show) return null;

        return (
            <div className="modal d-block" style={{ background: "rgba(0,0,0,0.5)", backdropFilter: "blur(2px)" }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0" style={{ borderRadius: '12px' }}>
                        <div className="modal-header border-0" style={{ background: '#193e6c', color: 'white', borderRadius: '12px 12px 0 0' }}>
                            <h5 className="modal-title">
                                Fix Issues
                            </h5>
                            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
                        </div>

                        <div className="modal-body py-4">
                            <div className='d-flex'>
                                <div className="mb-3 w-50">
                                    <label className="form-label text-muted">Date</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        disabled
                                        value={formatTimestamp(timestamp)}
                                        style={{ borderRadius: '6px' }}
                                    />
                                </div>
                                <div className='mx-2'></div>
                                <div className="mb-3 w-50">
                                    <label className="form-label text-muted">Raised By</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        disabled
                                        value={raisedBy}
                                        style={{ borderRadius: '6px' }}
                                    />
                                </div>
                            </div>
                            <div className="mb-3">
                                <label className="form-label text-muted">Resolution Remarks</label>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                    value={verifyRemarks}
                                    onChange={(e) => onRemarksChange(e.target.value)}
                                    style={{ borderRadius: '6px' }}
                                    placeholder="Add resolution remarks"
                                />
                            </div>
                        </div>

                        <div className="modal-footer border-0">
                            <button className="btn btn-light" onClick={onClose} style={{ borderRadius: '6px' }}>
                                Cancel
                            </button>
                            <button
                                className="btn btn-success"
                                onClick={onSubmit}
                                disabled={isSubmitDisabled}
                                style={{ borderRadius: '6px', background: '#193e6c', border: 'none' }}
                            >
                                Fixed Issue
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default IssueVerifyModal;